module.exports = __webpack_public_path__ + "img/sr_logo.fb32b0a5.svg";